/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import search from "../../assets/images/search.svg";
import downicon from "../../assets/images/down.svg";
import fileImageIcon from "../../assets/images/upload.svg"
import deleteIcon from '../../assets/images/delete.svg'
import plusIcon from '../../assets/images/plus_author.svg'
import GridLayout from '../../components/Media/GridLayout';
import TopBar from '../../components/TopBar';
import { deleteMedia, getAllMedia, getAllMediaDates, uploadMedia } from '../../api/mediaApi';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';

import './mediaGallery.css'

const MediaGallery = () => {

    const INITIAL_LOAD = 28;
    const LOAD_MORE_COUNT = 7;

    const dateRef = useRef();
    const [searchInput, setSearchInput] = useState("");
    const pulicationFileInputRef = useRef(null);
    const deletePopupRef = useRef();
    
    const [readFields, setReadFields] = useState(true);

    const [dateSelect, setDateSelect] = useState(false);
    const [selectedDateList, setSelectedDateList] = useState([]);

    const [uploadNewmedia, setUploadNewmedia] = useState(false);

    const [isImageDragging, setIsImageDragging] = useState(false);

    const [selectedImageGallery, setSelectedImageGallery] = useState([]);
    const [loadingFiles, setloadingFiles] = useState(false);

    const [selectedItems, setSelectedItems] = useState([])

    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [isDelLoading, setDelIsLoading] = useState(false);

    const [dateList, setDateList] = useState([]);

    const [fileList, setFileList] = useState({ '^image/': 'Images' })
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [allMedia, setAllMedia] = useState([]); // Store all media fetched from API
    const [displayMedia, setDisplayMedia] = useState([]); // Media currently displayed
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const [hasUserScrolled, setHasUserScrolled] = useState(false);

    const maxSizeInBytes = 128 * 1024 * 1024; // 128MB

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateRef.current && !dateRef.current.contains(event.target)) {
                setDateSelect(false);
            }
        };

        // Attach the event listener when the component mounts
        document.addEventListener("mousedown", handleClickOutside);

        // Detach the event listener when the component unmounts
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setFileList({
            '^image/': 'Images',
        })
    }, []);

    useEffect(() => {
        if (deleteConfirmation) {
            const checkIfClickedOutside = (e) => {
                if (deletePopupRef.current && !deletePopupRef.current.contains(e.target)) {
                    setDeleteConfirmation(false);
                }
            };
            document.addEventListener("mousedown", checkIfClickedOutside);

            return () => {
                document.removeEventListener("mousedown", checkIfClickedOutside);
            };
        }
    }, [deleteConfirmation]);

    useEffect(() => {
        fetchDateData()
    }, []);

    useEffect(() => {
        fetchData();
    }, [selectedDateList]);

    const fetchData = async () => {
        setIsLoadingData(true)
        try {
            const response = await getAllMedia({ search: searchInput, date: selectedDateList?.join(',') })
            if (response?.data?.length <= 0) {
                setIsLoadingData(false)
            }
            if (response?.success) {
                const allData = response?.data || [];
                setAllMedia(allData);
                setDisplayMedia(allData.slice(0, INITIAL_LOAD));
                setPage(1); // important
                setHasMore(allData.length > INITIAL_LOAD);
                setIsLoadingData(false)
            }
        } catch (error) {
            setIsLoadingData(false)
            console.log(error, "error");
        }
    }

    const fetchDateData = async () => {
        try {
            const response = await getAllMediaDates()
            setDateList(response?.data)
        } catch (error) {
            console.log(error, "error");
        }
    }

    const handleFileDragOver = (e) => {
        e.preventDefault();
    }

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const handlePublicationImageGalleryUpload = async (e) => {
        const files = e.target.files;
        let newErrorMessages = [];
        if (files) {

            for (const file of files) {

                const isAllowedFileType = Object.keys(fileList).some((pattern) => new RegExp(pattern).test(file.type));

                if (!isAllowedFileType) {
                    console.log(`File type ${file.type} is not allowed.`);
                    const errorMessage = 'This file type is not supported';
                    newErrorMessages.push(errorMessage);
                }

                if (file.size > maxSizeInBytes) {
                    console.log(`File ${file.name} exceeds the maximum size of 128MB.`);
                    continue; // Skip this file
                }

                // Stable local identifiers
                const tempId = Date.now() + Math.random();
                const mediaIndex = Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;

                const placeholderMedia = {
                    id: tempId,          // local temp id
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    url: '',
                    createdAt: '',
                    index: mediaIndex,
                    isLoading: true,
                    isError: false
                };

                setDisplayMedia((prevDisplayMedia) => [placeholderMedia, ...prevDisplayMedia]);

                try {
                    // 2️⃣ Upload
                    const uploadedMediaData = await uploadMedia(file, mediaIndex);

                    // 3️⃣ Update placeholder on success
                    setDisplayMedia((prev) =>
                        prev.map((media) =>
                            media.id === tempId
                                ? {
                                    ...media,
                                    ...uploadedMediaData,
                                    isLoading: false
                                }
                                : media
                        )
                    );
                } catch (error) {
                    console.error('Upload failed:', error);

                    newErrorMessages.push(
                        `Failed to upload ${file.name}`
                    );

                    // 4️⃣ Remove placeholder on failure
                    setDisplayMedia((prev) =>
                        prev.filter((media) => media.id !== tempId)
                    );
                    setAllMedia((prev) =>
                        prev.filter((media) => media.id !== tempId)
                    );
                }

                setloadingFiles(false);

            }
        } else {
            setloadingFiles(false);
        }
    }

    const handleGalleryImageDrop = async (e) => {
        e.preventDefault();
        let newErrorMessages = [];
        const files = e.dataTransfer.files;

        for (const file of files) {

            const isAllowedFileType = Object.keys(fileList).some((pattern) => new RegExp(pattern).test(file.type));

            if (!isAllowedFileType) {
                const errorMessage = 'This file type is not supported';
                newErrorMessages.push(errorMessage);
            }

            if (file.size > maxSizeInBytes) {
                console.log(`File ${file.name} exceeds the maximum size of 128MB.`);
                continue; // Skip this file
            }


            // Stable local identifiers
            const tempId = Date.now() + Math.random();
            const mediaIndex = Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;

            const placeholderMedia = {
                id: tempId,          // local temp id
                name: file.name,
                type: file.type,
                size: file.size,
                url: '',
                createdAt: '',
                index: mediaIndex,
                isLoading: true,
                isError: false
            };

            setDisplayMedia((prevDisplayMedia) => [placeholderMedia, ...prevDisplayMedia]);

            try {
                // 2️⃣ Upload
                const uploadedMediaData = await uploadMedia(file, mediaIndex);

                // 3️⃣ Update placeholder on success
                setDisplayMedia((prev) =>
                    prev.map((media) =>
                        media.id === tempId
                            ? {
                                ...media,
                                ...uploadedMediaData,
                                isLoading: false
                            }
                            : media
                    )
                );
            } catch (error) {
                console.error('Upload failed:', error);

                newErrorMessages.push(
                    `Failed to upload ${file.name}`
                );

                // 4️⃣ Remove placeholder on failure
                setDisplayMedia((prev) =>
                    prev.filter((media) => media.id !== tempId)
                );
                setAllMedia((prev) =>
                    prev.filter((media) => media.id !== tempId)
                );
            }
        }

        setIsImageDragging(false);
    };
    const handleDeleteMeida = () => {
        if (selectedItems && selectedItems.length > 0) {
            setDeleteConfirmation(true);
        }
    }

    const handleSearch = () => {
        setPage(1);
        setHasMore(true);
        fetchData();
    }

    const confirmDelete = async () => {
        try {
            setDelIsLoading(true);

            await deleteMedia(selectedItems);

            const updatedDisplayMedia = displayMedia.filter(media => !selectedItems.includes(media.id));
            const updatedAllMedia = allMedia.filter(media => !selectedItems.includes(media.id));
            setDisplayMedia(updatedDisplayMedia);
            setAllMedia(updatedAllMedia);
            setSelectedItems([])

            setDelIsLoading(false);
            setDeleteConfirmation(false);

        } catch (error) {
            setDelIsLoading(false);
            console.log(error)
        }
    };
    const fetchMoreData = () => {
        if (isFetchingMore) return;

        setHasUserScrolled(true); // 👈 key line
        setIsFetchingMore(true);

        requestAnimationFrame(() => {
            setTimeout(() => {
                const startIndex = INITIAL_LOAD + (page - 1) * LOAD_MORE_COUNT;
                const endIndex = startIndex + LOAD_MORE_COUNT;

                const nextItems = allMedia.slice(startIndex, endIndex);

                if (nextItems.length === 0) {
                    setHasMore(false);
                    setIsFetchingMore(false);
                    return;
                }

                setDisplayMedia(prev => [...prev, ...nextItems]);
                setPage(prev => prev + 1);
                setHasMore(endIndex < allMedia.length);
                setIsFetchingMore(false);
            }, 400);
        });
    };

    const InfiniteLoader = () => (
        <div className='infinateLoader'>
            <div className="infinatescroll ringLoader">
            </div>
        </div>
    );

    return (
        <>
            <TopBar />
            <section className='dashboard mediaGallery'>
                <div className="container">
                    <div className="pagesSearch">
                        <div className="pageSearchTop">
                            <div className="pageSearchInput">
                                <input
                                    type="text"
                                    name="pages_search"
                                    id="pages_search"
                                    className="inputFields"
                                    placeholder="Search"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    autoComplete="off"
                                    readOnly={readFields}
                                    onFocus={() => setReadFields(false)}
                                    onBlur={() => setReadFields(true)}
                                />
                                <img src={search} alt="Search" className='pageSearchIcon' />
                            </div>

                            <button className={`add-btn`} onClick={() => handleSearch()}>Search</button>
                        </div>
                        <div className="pagesSearchIcon">

                            {dateList && dateList.length > 0 &&
                                <div ref={dateRef} className="dropdown-wrapper">
                                    <button className="dropdown-header" onClick={(e) => setDateSelect(!dateSelect)}>
                                        <span className="title">All Dates{" "}
                                            {selectedDateList.length > 0 ? `(${selectedDateList.length})` : ""}
                                        </span>
                                        <span className={`arrow ${dateSelect ? "rotate" : ""}`}>
                                            <img src={downicon} alt='down-icon'/>
                                        </span>
                                    </button>
                                    {
                                        dateSelect === true &&
                                        <div className="dropdown-list">
                                            {dateList.map((date) => (
                                                <li className="dropdown-item" key={date} onClick={() => {
                                                    const dates = selectedDateList.includes(date)
                                                        ? selectedDateList.filter(
                                                            (selectdate) =>
                                                                selectdate !== date
                                                        )
                                                        : [...selectedDateList, date];
                                                    setSelectedDateList(dates);
                                                }}>
                                                    <input type="checkbox" checked={selectedDateList.includes(date)} />
                                                    <span>{date}</span>
                                                </li>
                                            ))
                                            }
                                        </div>
                                    }
                                </div>
                            }

                            <div className="pagesSearchbtn">
                                <button className='addNewMediaButton' onClick={() => setUploadNewmedia(!uploadNewmedia)}>
                                    <img src={plusIcon} alt="plus-icon" className='plusIcon' />
                                    New file
                                </button>
                            </div>
                            <div className='deleteIcon' onClick={handleDeleteMeida}>
                                <img className='deleteIconImage' src={deleteIcon} alt="Clear Input" />
                            </div>
                        </div>
                    </div>
                </div>

                {uploadNewmedia === true &&
                    <div>
                        <div className={`newpageLeftRow textBlock ulpoadImageBlock ${loadingFiles ? 'uploadRunning' : ''}`}>
                            <div className={isImageDragging ? `draging fileUploadBox` : `fileUploadBox`}
                                onDragOver={handleFileDragOver}
                                onDragLeave={handleFileDragLeave}
                                onDrop={handleGalleryImageDrop}
                            >
                                <input
                                    type="file"
                                    ref={pulicationFileInputRef}
                                    id="pulication-file"
                                    multiple
                                    onChange={handlePublicationImageGalleryUpload}
                                    accept=".jpg, .png, .pdf"
                                    hidden
                                />
                                <div className="uploadFileBlock" onClick={() => document.getElementById("pulication-file").click()} >
                                    <div className="featureImgMiddleContent">
                                        <img className="fileUploadCover_Img" src={fileImageIcon} alt="FeaturedImage" />
                                        <p className="newPageImageUploadText">
                                            <span>Click to upload</span> or drag and drop{" "}
                                            <br />

                                            <>
                                                <b>Images: </b> JPG, PNG, PDF
                                                <br />
                                                <b>Videos: </b> MP4, MOV, AVI, WMV, AVCHD, WebM, FLV
                                                <br />
                                            </>
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* {validateImage === true && 
                            <p className="validateError">Some selected files have invalid type or size. Please choose valid images (jpg, png) or PDF files within 128MB.</p>
                        }
                        {validateFileImage === true &&
                            <p className="validateError">The field is not filled</p>
                        }
                        {planError === true &&
                            <p className="validateError" onClick={handleUpgrade} >You Not Allow To upload this File, Upgrade Your Plan.</p>
                        } */}

                    </div>
                }

                <div className="container">
                    <InfiniteScroll
                        dataLength={displayMedia.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={
                            hasUserScrolled && isFetchingMore ? <InfiniteLoader /> : null
                        }
                        scrollThreshold="200px"
                    >

                        <GridLayout userMedia={displayMedia} setUserMedia={setDisplayMedia} selectedImageGallery={selectedImageGallery} loadingFiles={loadingFiles} setSelectedImageGallery={setSelectedImageGallery} setUploadNewmedia={setUploadNewmedia} uploadNewmedia={uploadNewmedia} selectedItems={selectedItems} setSelectedItems={setSelectedItems} isLoadingData={isLoadingData} />
                    </InfiniteScroll>
                </div>
            </section>

            <DeleteConfirmationPopup
                showDeletePopup={deleteConfirmation}
                reference={deletePopupRef}
                confirmDelete={confirmDelete}
                setShowDeletePopup={setDeleteConfirmation}
                onCancel={() => setDeleteConfirmation(false)}
                isLoading={isDelLoading}
                title={'Media'}
                description={`Are you sure you want to delete ${(selectedItems && selectedItems.length > 1) ? "these" : "this"} media? This action cannot be undone.`}
            />
        </>
    );
}

export default MediaGallery;
